export default function IconSymbolEntrance(props) {
  return (
    <svg width="16" height="16" viewBox="-55 -55 110 110" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="0" cy="0" r="50"/><polyline points="21.5,15.9 21.5,-34.4"/><polyline points="-26.2,15.9 -26.2,13.2"/><path d="M21.5,-34.4 A47.7,47.7 0 0,0 -26.2,13.2"/>
    </svg>
  )
}
